import type { RefObject } from 'react';
import { useState, useEffect } from 'react';

export const useIsVisible = <T extends Element>(ref: RefObject<T | null>) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (!ref?.current) {
      return;
    }
    const observer = new IntersectionObserver(([entry]) =>
      setIntersecting(entry.isIntersecting),
    );

    observer.observe(ref?.current);
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isIntersecting;
};
